import React from "react"
export const InlineError = ({ text, className }) => (
  <span className={`text-danger ${className}`}>{text}</span>
)
